import { render, staticRenderFns } from "./ServiceNeedApproval.vue?vue&type=template&id=530da2ff"
import script from "./ServiceNeedApproval.vue?vue&type=script&lang=js"
export * from "./ServiceNeedApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports